import SiteNav from '@/components/organisms/SiteNav'
import FooterStub from '@/components/organisms/FooterStub'
import SiteButton from '@/components/atoms/SiteButton'

// Product descriptions follow the marketing matrix; quotes are scoped by the team.
export function PricingPage() {
    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="site-shell">
                <SiteNav />

                <section className="pt-section-gap">
                    <h1 className="max-w-2xl text-4xl font-medium text-unimo-slate lg:text-6xl">
                        Model, watch, and report on your site.
                    </h1>
                    <p className="mt-6 max-w-2xl text-lg font-light text-unimo-slate lg:text-xl">
                        Choose the tools your site needs. Tell us what you’re planning and we’ll help you find the right
                        fit, with a quote for your project.
                    </p>
                </section>

                <section className="pt-section-headline-gap-bottom">
                    {/* Lead product card follows the shared design system. */}
                    <div className="relative overflow-hidden rounded-site-panel border-[3px] border-unimo-site-cta bg-gradient-to-bl from-unimo-site-blue-light to-unimo-stone p-8 lg:p-10">
                        <div className="grid gap-8 lg:grid-cols-[1.15fr_1fr]">
                            <div>
                                <h2 className="text-3xl font-medium text-unimo-slate">unimoBuild</h2>
                                <p className="mt-2 max-w-md font-light text-unimo-slate lg:text-lg">
                                    Turn any site document into a living 3D model - in minutes.
                                </p>
                                <ul className="mt-6 space-y-2 text-sm font-light text-unimo-site-grey-700">
                                    <li>AI-driven digital twin tool that creates accurate, living 3D models in minutes.</li>
                                    <li>Import PDFs, screenshots, photos and IFC exports from Navisworks or Revit, then ask it what you need.</li>
                                    <li>No specialist team or lengthy training needed. Install it, open it, start building.</li>
                                </ul>
                            </div>
                            <div className="flex flex-col">
                                <div className="text-xs font-medium uppercase tracking-wide text-unimo-site-grey-500">Let’s talk about your project</div>
                                <div className="mt-2 text-4xl font-medium text-unimo-slate">
                                    Contact us
                                </div>
                                <p className="mt-1 text-xs text-unimo-site-grey-500">
                                    Tell us about your site and what you’d like to build.
                                </p>
                                <div className="mt-auto pt-6">
                            <SiteButton href="/contact?topic=pricing" className="w-full sm:w-fit">
                                    Contact us
                                </SiteButton>
                            </div>
                            </div>
                        </div>
                    </div>

                    {/* unimoLive and unimoReport — enterprise, priced per deployment, talk
                        to sales rather than a direct-purchase price. */}
                    <div className="mt-4 grid gap-4 md:grid-cols-2">
                        <div className="flex flex-col rounded-site-card border-[3px] border-unimo-site-grey-300 p-8">
                            <h2 className="text-2xl font-medium text-unimo-slate">unimoLive</h2>
                            <p className="mt-2 font-light text-unimo-slate">Everything happening on your site, visible in real time.</p>
                            <div className="mt-6 text-xl font-medium text-unimo-slate">Contact us for pricing</div>
                            <p className="mt-1 text-xs text-unimo-site-grey-500">Tell us about your sensors and the sites you need to monitor.</p>
                            <ul className="mt-6 space-y-2 text-sm font-light text-unimo-site-grey-700">
                                <li>Out of the box compatible with almost every sensor on the planet.</li>
                                <li>Monitors weather, noise, power and any other data your site produces.</li>
                                <li>One view of everything, updating as it happens, so you can intervene before a change becomes a bigger problem.</li>
                            </ul>
                            <div className="mt-auto pt-6">
                            <SiteButton href="/contact?topic=pricing" variant="ghost" className="w-full sm:w-fit">
                                Contact us
                            </SiteButton>
                            </div>
                        </div>

                        <div className="flex flex-col rounded-site-card border-[3px] border-unimo-site-grey-300 p-8">
                            <h2 className="text-2xl font-medium text-unimo-slate">unimoReport</h2>
                            <p className="mt-2 font-light text-unimo-slate">No IT tickets. Accurate dashboards, in seconds.</p>
                            <div className="mt-6 text-xl font-medium text-unimo-slate">Contact us for pricing</div>
                            <p className="mt-1 text-xs text-unimo-site-grey-500">Runs on unimoLive data, or standalone against your own.</p>
                            <ul className="mt-6 space-y-2 text-sm font-light text-unimo-site-grey-700">
                                <li>Turns complex datasets into intelligence that is visualised, actionable and ready to use.</li>
                                <li>Pull in your unimoLive data or connect your own from tools like Microsoft Fabric.</li>
                                <li>Build custom dashboards and stay compliant with on-demand reporting.</li>
                            </ul>
                            <div className="mt-auto pt-6">
                            <SiteButton href="/contact?topic=pricing" variant="ghost" className="w-full sm:w-fit">
                                Contact us
                            </SiteButton>
                            </div>
                        </div>
                    </div>
                </section>

                <FooterStub />
            </div>

        </div>
    )
}

export default PricingPage
